
export const MeetLinkPaymentToMento = ({ data }) => {
  
  if (!data) {
    throw new Error('data do not exist');
  }

  const date = new Date(data.sessionDate);
  const options = { weekday: 'long', month: 'long', day: 'numeric' };
  const formattedDate = date.toLocaleDateString('en-US', options);
  const currentYear = new Date().getFullYear();

  return (
    <div style={{
      margin: 0,
      padding: 0,
      fontFamily: "'Google Sans', Arial, sans-serif",
      backgroundColor: '#ffffff',
      color: '#202124'
    }}>
      <div style={{ maxWidth: '1100px', margin: '0 auto', backgroundColor: '#ffffff' }}>
        
        {/* Header Card */}
        <div style={{
          fontFamily: 'Arial, sans-serif',
          border: '1px solid #e1e4e8',
          borderRadius: '8px',
          padding: '20px',
          backgroundColor: '#f9f9f9',
          margin: '20px'
        }}>
          
          <div style={{
            fontWeight: 'bold',
            fontSize: '14px',
            color: '#444',
            marginBottom: '10px'
          }}>
            {formattedDate} • {data.sessionTime}
          </div>
          
          <div style={{
            fontSize: '20px',
            fontWeight: '500',
            color: '#000',
            marginBottom: '15px'
          }}>
            New Therapy Session Scheduled - Client: {data.name}
          </div>
          
          <div style={{
            display: 'flex',
            alignItems: 'center',
            marginBottom: '10px',
            color: '#333',
            fontSize: '14px'
          }}>
            <div style={{ marginRight: '8px', fontSize: '20px', lineHeight: '20px' }}>
              📍
            </div>
            <div>
              <a style={{ textDecoration: 'none', color: '#1967d2' }} href={data.meetLink}>
                Google Meet
              </a>
            </div>
          </div>
          
          <div style={{
            display: 'flex',
            alignItems: 'center',
            marginBottom: '10px',
            color: '#333',
            fontSize: '14px'
          }}>
            <div style={{ marginRight: '8px', fontSize: '20px', lineHeight: '20px' }}>
              👤
            </div>
            <div>Client: {data.name}</div>
          </div>
          
          <div style={{
            display: 'flex',
            alignItems: 'center',
            marginBottom: '20px',
            fontWeight: 'bold',
            fontSize: '14px',
            color: '#333'
          }}>
            <div style={{ marginRight: '8px', fontSize: '20px', lineHeight: '20px' }}>
              📅
            </div>
            <div>Added to your Mento Calendar</div>
          </div>
          
          <button style={{
            backgroundColor: '#2f59ec',
            color: 'white',
            border: 'none',
            padding: '10px 20px',
            fontSize: '14px',
            borderRadius: '6px',
            cursor: 'pointer'
          }}>
            <a style={{ textDecoration: 'none', color: 'white' }} href={data.htmlLink}>
              View in Calendar
            </a>
          </button>
        </div>
        
        {/* Main Content */}
        <div style={{ display: 'flex', backgroundColor: '#ffffff' }}>
          
          {/* Left Content */}
          <div style={{ padding: '0 24px 24px 24px', flex: 1 }}>
            <p style={{ margin: '16px 0', fontSize: '14px', color: '#202124' }}>
              A new therapy session {data.sessionTime} has been scheduled with client {data.name}.
            </p>
            
            <div style={{ margin: '24px 0' }}>
              <p style={{
                margin: '0 0 16px 0',
                fontSize: '16px',
                color: '#202124',
                fontWeight: '600'
              }}>
                A counselling session {data.sessionTime} has been successfully booked and payment has been received.
              </p>
              
              <div style={{ margin: '20px 0' }}>
                <p style={{
                  margin: '0 0 12px 0',
                  fontSize: '14px',
                  color: '#202124',
                  fontWeight: '500'
                }}>
                  Session Details:
                </p>
                <div style={{ fontSize: '14px', color: '#202124', lineHeight: '1.6' }}>
                  <p style={{ margin: '8px 0' }}>
                    <strong>Client:</strong> {data.name}
                  </p>
                  <p style={{ margin: '8px 0' }}>
                    <strong>Date:</strong> {formattedDate} {currentYear}
                  </p>
                  <p style={{ margin: '8px 0' }}>
                    <strong>Time:</strong> {data.sessionTime}
                  </p>
                  <p style={{ margin: '8px 0' }}>
                    <strong>Session Type:</strong> {data.sessionType || 'Online Therapy'}
                  </p>
                  <p style={{ margin: '8px 0' }}>
                    <strong>Payment Status:</strong> ✅ Confirmed
                  </p>
                </div>
              </div>
              
              <div style={{ margin: '20px 0' }}>
                <p style={{ margin: '8px 0', fontSize: '14px', color: '#202124' }}>
                  Best regards,<br />Mento Support Team
                </p>
                <p style={{ margin: '8px 0', fontSize: '14px', color: '#202124' }}>
                  <a href="https://www.mento.in" style={{ color: '#1967d2', textDecoration: 'none' }}>
                    www.mento.in
                  </a>
                </p>
              </div>
              
              <div style={{ margin: '16px 0', fontSize: '12px', color: '#5f6368' }}>
                <a href="https://www.instagram.com/mento.in" style={{ color: '#1967d2', textDecoration: 'none', marginRight: '15px' }}>
                  Instagram
                </a>
                <a href="http://wa.me/9120719120" style={{ color: '#1967d2', textDecoration: 'none', marginRight: '15px' }}>
                  WhatsApp
                </a>
                <a href="https://m.facebook.com/people/Mento/61566015786803" style={{ color: '#1967d2', textDecoration: 'none', marginRight: '15px' }}>
                  Facebook
                </a>
                <a href="https://in.linkedin.com/company/connectmento" style={{ color: '#1967d2', textDecoration: 'none' }}>
                  LinkedIn
                </a>
              </div>
            </div>
          </div>
          
          {/* Right Side Panel */}
          <div style={{
            width: '300px',
            backgroundColor: '#f8f9fa',
            padding: '24px',
            borderTop: '1px solid #e8eaed'
          }}>
            <p style={{ margin: '0 0 8px 0', fontWeight: '500' }}>Session Meeting Link</p>
            <p style={{ margin: '0 0 16px 0', fontSize: '14px', wordBreak: 'break-all' }}>
              <a href={data.meetLink} style={{ color: '#1967d2', textDecoration: 'none' }}>
                {data.meetLink}
              </a>
            </p>
            
            <div style={{
              backgroundColor: '#1a73e8',
              color: 'white',
              padding: '12px 24px',
              borderRadius: '4px',
              textAlign: 'center',
              marginBottom: '16px'
            }}>
              <a href={data.meetLink} style={{
                color: 'white',
                textDecoration: 'none',
                fontSize: '14px',
                fontWeight: '500'
              }}>
                Join with Google Meet
              </a>
            </div>
            
            <div style={{
              backgroundColor: '#009479',
              color: 'white',
              padding: '12px 24px',
              borderRadius: '4px',
              textAlign: 'center',
              marginTop: '20px'
            }}>
              <a href="http://wa.me/9120719120" style={{
                color: 'white',
                textDecoration: 'none',
                fontSize: '14px',
                fontWeight: '500'
              }}>
                Contact Support
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};




export const MeetLinkPaymentToUser = ({ data }) => {
  if (!data) {
    throw new Error('data do not exist');
  }

  const date = new Date(data.sessionDate);
  const options = { weekday: 'long', month: 'long', day: 'numeric' };
  const formattedDate = date.toLocaleDateString('en-US', options);
  const currentYear = new Date().getFullYear();

  return (
    <div style={{
      margin: 0,
      padding: 0,
      fontFamily: "'Google Sans', Arial, sans-serif",
      backgroundColor: '#ffffff',
      color: '#202124'
    }}>
      {/* Header */}
      <header style={{ maxWidth: '1100px', margin: '0 auto', backgroundColor: '#ffffff' }}>
        <div style={{
          fontFamily: 'Arial, sans-serif',
          border: '1px solid #e1e4e8',
          borderRadius: '8px',
          padding: '20px',
          backgroundColor: '#f9f9f9',
          margin: '20px'
        }}>
          <div style={{
            fontWeight: 'bold',
            fontSize: '14px',
            color: '#444',
            marginBottom: '10px'
          }}>
            {formattedDate} • {data.sessionTime}
          </div>
          
          <div style={{
            fontSize: '20px',
            fontWeight: '500',
            color: '#000',
            marginBottom: '15px'
          }}>
            Hi {data.name}, Therapy session {data.sessionTime} has been scheduled
          </div>
          
          <div style={{
            display: 'flex',
            alignItems: 'center',
            marginBottom: '10px',
            color: '#333',
            fontSize: '14px'
          }}>
            <div style={{ marginRight: '8px', fontSize: '20px', lineHeight: '20px' }}>
              📍
            </div>
            <div>Google Meet (instructions in description)</div>
          </div>
          
          <div style={{
            display: 'flex',
            alignItems: 'center',
            marginBottom: '10px',
            color: '#333',
            fontSize: '14px'
          }}>
            <div style={{ marginRight: '8px', fontSize: '20px', lineHeight: '20px' }}>
              👤
            </div>
            <div style={{ paddingLeft: '1rem' }}>Mento - Organizer</div>
          </div>
          
          <div style={{
            display: 'flex',
            alignItems: 'center',
            marginBottom: '20px',
            fontWeight: 'bold',
            fontSize: '14px',
            color: '#333'
          }}>
            <div style={{ marginRight: '8px', fontSize: '20px', lineHeight: '20px' }}>
              📅
            </div>
            <div>On your Google Calendar</div>
          </div>
          
          <button style={{
            backgroundColor: '#2f59ec',
            color: 'white',
            border: 'none',
            padding: '10px 20px',
            fontSize: '14px',
            borderRadius: '6px',
            cursor: 'pointer'
          }}>
            <a style={{ textDecoration: 'none', color: 'white' }} href={data.htmlLink}>
              Add to Calendar
            </a>
          </button>
        </div>
      </header>

      {/* Main Container */}
      <div style={{ maxWidth: '1100px', margin: '0 auto', backgroundColor: '#ffffff' }}>
        
        {/* Header Greeting */}
        <div style={{ padding: '20px 24px', borderBottom: '1px solid #e8eaed' }}>
          <p style={{ margin: 0, fontSize: '14px', color: '#202124' }}>
            Hi {data.name},
          </p>
        </div>
        
        <div style={{ display: 'flex' }}>
          {/* Meeting Details */}
          <div style={{ padding: '0 24px 24px 24px', flex: 1 }}>
            <p style={{ margin: '16px 0', fontSize: '14px', color: '#202124' }}>
              Therapy session {data.sessionTime} has been scheduled.
            </p>
            
            {/* Session Confirmation */}
            <div style={{ margin: '24px 0' }}>
              <p style={{
                margin: '0 0 16px 0',
                fontSize: '16px',
                color: '#202124',
                fontWeight: '600'
              }}>
                We've received your payment and your counselling session {data.sessionTime} has been successfully scheduled.
              </p>
              
              <div style={{ margin: '20px 0' }}>
                <p style={{
                  margin: '0 0 12px 0',
                  fontSize: '14px',
                  color: '#202124',
                  fontWeight: '500'
                }}>
                  Session Details:
                </p>
                <div style={{ fontSize: '14px', color: '#202124', lineHeight: '1.6' }}>
                  <p style={{ margin: '8px 0' }}>
                    <strong>Date:</strong> {formattedDate} {currentYear}
                  </p>
                  <p style={{ margin: '8px 0' }}>
                    <strong>Time:</strong> {data.sessionTime}
                  </p>
                </div>
              </div>

              <div style={{ margin: '20px 0' }}>
                <p style={{
                  margin: '0 0 12px 0',
                  fontSize: '14px',
                  color: '#202124',
                  fontWeight: '500'
                }}>
                  Important Notes:
                </p>
                <div style={{ fontSize: '14px', color: '#202124', lineHeight: '1.5' }}>
                  <p style={{ margin: '8px 0' }}>
                    • This is a confirmation email. Hence, no reply is required.
                  </p>
                  <p style={{ margin: '8px 0' }}>
                    • If you're running late, please inform us in advance on WhatsApp or contact our customer support. This helps ensure your session is not marked as a no-show. Therapists can wait for you, but without prior notice, the session will be considered missed and marked accordingly.
                  </p>
                </div>
              </div>

              <div style={{ margin: '20px 0' }}>
                <p style={{
                  margin: '0 0 12px 0',
                  fontSize: '14px',
                  color: '#202124',
                  fontWeight: '500'
                }}>
                  Need support?
                </p>
                <p style={{ margin: '8px 0', fontSize: '14px', color: '#202124' }}>
                  Feel free to message us on{' '}
                  <a href="https://wa.me/+919120719120" style={{ color: '#1967d2', textDecoration: 'none' }}>
                    WhatsApp
                  </a>{' '}
                  for any assistance or questions.
                </p>
                <p style={{ margin: '8px 0', fontSize: '14px', color: '#202124' }}>
                  Stay connected with us on{' '}
                  <a href="https://instagram.com/mento.in" style={{ color: '#1967d2', textDecoration: 'none' }}>
                    Instagram
                  </a>{' '}
                  for mental wellness insights and daily tips.
                </p>
              </div>

              <div style={{ margin: '20px 0' }}>
                <p style={{ margin: '8px 0', fontSize: '14px', color: '#202124' }}>
                  Thank you once again for trusting us with your mental wellness journey.
                </p>
                <p style={{ margin: '8px 0', fontSize: '14px', color: '#202124' }}>
                  We're with you, every step of the way 🌱
                </p>
              </div>

              <div style={{ margin: '20px 0' }}>
                <p style={{ margin: '8px 0', fontSize: '14px', color: '#202124' }}>
                  Warm regards,<br />Team Mento
                </p>
                <p style={{ margin: '8px 0', fontSize: '14px', color: '#202124' }}>
                  <a href="https://www.mento.in" style={{ color: '#1967d2', textDecoration: 'none' }}>
                    www.mento.in
                  </a>
                </p>
              </div>

              <div style={{ margin: '16px 0', fontSize: '12px', color: '#5f6368' }}>
                <a href="https://www.instagram.com/mento.in" style={{ color: '#1967d2', textDecoration: 'none', marginRight: '15px' }}>
                  Instagram
                </a>
                <a href="http://wa.me/9120719120" style={{ color: '#1967d2', textDecoration: 'none', marginRight: '15px' }}>
                  WhatsApp
                </a>
                <a href="https://m.facebook.com/people/Mento/61566015786803" style={{ color: '#1967d2', textDecoration: 'none', marginRight: '15px' }}>
                  Facebook
                </a>
                <a href="https://in.linkedin.com/company/connectmento" style={{ color: '#1967d2', textDecoration: 'none' }}>
                  LinkedIn
                </a>
              </div>
            </div>
          </div>
          
          {/* Right Side Panel */}
          <div style={{
            width: '300px',
            backgroundColor: '#f8f9fa',
            padding: '24px',
            borderTop: '1px solid #e8eaed'
          }}>
            <p style={{ margin: '0 0 8px 0', fontWeight: '500' }}>Meeting Link</p>
            <p style={{ margin: '0 0 16px 0', fontSize: '14px', wordBreak: 'break-all' }}>
              <a href={data.meetLink} style={{
                textDecoration: 'none',
                color: '#1967d2',
                fontSize: '14px',
                fontWeight: '500'
              }}>
                {data.meetLink}
              </a>
            </p>

            <div style={{
              backgroundColor: '#1a73e8',
              color: 'white',
              padding: '12px 24px',
              borderRadius: '4px',
              textAlign: 'center',
              marginBottom: '16px'
            }}>
              <a href={data.meetLink} style={{
                color: 'white',
                textDecoration: 'none',
                fontSize: '14px',
                fontWeight: '500'
              }}>
                Join with Google Meet
              </a>
            </div>
            
            <div style={{
              backgroundColor: '#009479',
              color: 'white',
              padding: '12px 24px',
              borderRadius: '4px',
              textAlign: 'center',
              marginTop: '20px'
            }}>
              <a href="http://wa.me/9120719120" style={{
                color: 'white',
                textDecoration: 'none',
                fontSize: '14px',
                fontWeight: '500'
              }}>
                Need Support
              </a>
            </div>
          </div>
        </div>

        {/* Footer */}
        <div style={{
          padding: '16px 24px',
          borderTop: '1px solid #e8eaed',
          textAlign: 'center'
        }}>
          <p style={{ margin: 0, fontSize: '12px', color: '#5f6368' }}>
            This invitation was sent by Mento
          </p>
        </div>
      </div>
    </div>
  );
};





// export const MeetLinkPaymentToUser = ({data})=>{

// if(!data){
//     throw new Error('data do not exist')
// }
// const date = new Date(data.sessionDate);


// const options = { weekday: 'long', month: 'long', day: 'numeric' };
// const formatted_date = date.toLocaleDateString('en-US', options);
// //  console.log(formatted); // 👉 "Friday, July 25"

//  // Output: Friday

//  const currentYear = new Date().getFullYear();


// return ` 
// <!DOCTYPE html>
// <html lang="en">
// <head>
//     <meta charset="UTF-8">
//     <meta name="viewport" content="width=device-width, initial-scale=1.0">
//     <title>Meeting Invitation</title>
// </head>
// <body style="margin: 0; padding: 0; font-family: 'Google Sans', Arial, sans-serif; background-color: #ffffff; color: #202124;">
//     <header  style="max-width: 1100px; margin: 0 auto; background-color: #ffffff;">
//         <div style="font-family: Arial, sans-serif;  border: 1px solid #e1e4e8; border-radius: 8px; padding: 20px; background-color: #f9f9f9;">
//   <div style="font-weight: bold; font-size: 14px; color: #444; margin-bottom: 10px;">${formatted_date}• ${data.sessionTime}</div>
//   <div style="font-size: 20px; font-weight: 500; color: #000; margin-bottom: 15px;">Hi Pradeep, Therapy session ${data.sessionTime} has been scheduled </div>
//   <div style="display: flex; align-items: center; margin-bottom: 10px; color: #333; font-size: 14px;">
//     <div style="margin-right: 8px; font-size: 20px; line-height: 20px;">
//         <svg viewBox="0 -960 960 960" height="24" width="24" focusable="false" class=" aoH"><path d="M480.28-96q-13.7,0-23.49-7.5T443-123q-19-53-45.5-100.5T321-335q-49-63-79.5-121T211-595.21Q211-707 289.3-785.5T480-864t190.7,78.42T749-594.57Q749-507 715.5-449.5T639-335q-52,68-78.5,114.5T517-123q-5,12-14.5,19.5T480.28-96ZM480-223q17-34 38.5-67.27T582-379q42-54 68.5-100.36T677-595q0-81-58-139T479.5-792t-139,58T283-595q0,69.29 27,115.64T378-379q42,55.45 63.5,88.73T480-223Zm0-275q40,0 68.5-28.5T577-595t-28.5-68.5T480-692t-68.5,28.5T383-595t28.5,68.5T480-498Zm0-97Z"></path></svg>
//     </div>
//     <div>Google Meet (instructions in description)</div>
//   </div>
//   <div style="display: flex; align-items: center; margin-bottom: 10px; color: #333; font-size: 14px;">
//     <div style="margin-right: 1px; font-size: 20px; line-height: 20px;">
//     </div>
//     <div  style="margin-left: rem;">

//         <svg viewBox="0 -960 960 960" height="24" width="24" focusable="false" class=" aoH"><path d="M96-192v-92q0-25.78 12.5-47.39T143-366q54-32 114.5-49T384-432t126.5,17T625-366q22,13 34.5,34.61T672-284v92H96Zm648,0v-92q0-42-19.5-78T672-421q39,8 75.5,21.5T817-366q22,13 34.5,34.67T864-284v92H744ZM384-480q-60,0-102-42T240-624t42-102t102-42t102,42t42,102T486-522T384-480ZM720-624q0,60-42,102T576-480q-8,0-15-0.5T546-483q25-29 39.5-64.5T600-624t-14.5-76.5T546-765q8-2 15-2.5t15-0.5q60,0 102,42t42,102ZM168-264H600v-20q0-6.47-3.03-11.76T589-304q-47-27-99-41.5T384-360T278-346t-99,42q-4.95,2.83-7.98,7.91T168-284.09V-264ZM384.21-552Q414-552 435-573.21t21-51T434.79-675t-51-21T333-674.79t-21,51T333.21-573t51,21ZM384-264Zm0-360Z"></path></svg>

//     </div>
//     <div style="padding-left: 1rem;">Mento - Organizer</div>
//   </div>
//   <div style="display: flex; align-items: center; margin-bottom: 20px; font-weight: bold; font-size: 14px; color: #333;">
//     <div style="margin-right: 8px;"><svg id="Standard_product_icon" data-name="Standard product icon" width="24" height="24" viewBox="0 0 192 192" focusable="false" class=" aoH"><defs><style>.cls-1{fill:none;}.cls-2{fill:#fff;}.cls-3{fill:#4285f4;}.cls-4{fill:#ea4335;}.cls-5{fill:#34a853;}.cls-6{fill:#188038;}.cls-7{fill:#fbbc04;}.cls-8{fill:#1967d2;}</style></defs><rect id="bounding_box" data-name="bounding box" class="cls-1" width="192" height="192"></rect><g id="art_layer" data-name="art layer"><g id="art_layer-2" data-name="art layer"><polygon class="cls-2" points="136 56 100 52 56 56 52 96 56 136 96 141 136 136 140 95 136 56"></polygon><polygon class="cls-4" points="136 172 172 136 154 128 136 136 128 154 136 172"></polygon><polygon class="cls-5" points="48 154 56 172 136 172 136 136 56 136 48 154"></polygon><polygon class="cls-7" points="136 56 136 136 172 136 172 56 154 48 136 56"></polygon><path class="cls-3" d="M83,121.09a17.84,17.84,0,0,1-6.46-1.23A16.62,16.62,0,0,1,70.8,116a16.4,16.4,0,0,1-3.74-6.8l6.87-2.79A10.4,10.4,0,0,0,77.26,112,8.65,8.65,0,0,0,83,114a9.08,9.08,0,0,0,4.15-1,7.73,7.73,0,0,0,3.13-2.65,6.77,6.77,0,0,0-1.43-9.25,10.12,10.12,0,0,0-6.6-2.1h-4V92.32h3.67a9,9,0,0,0,5.58-1.76,6,6,0,0,0,2.38-5.1A5.47,5.47,0,0,0,87.73,81a7.6,7.6,0,0,0-5.17-1.77,6.79,6.79,0,0,0-5.23,1.9A10.33,10.33,0,0,0,74.88,85l-6.67-2.79a15.69,15.69,0,0,1,2.52-4.35A15.09,15.09,0,0,1,75.49,74a14.86,14.86,0,0,1,7.07-1.56A17.07,17.07,0,0,1,90.18,74a12.63,12.63,0,0,1,5.17,4.49A11.37,11.37,0,0,1,97.25,85a10.54,10.54,0,0,1-1.9,6.53,12.2,12.2,0,0,1-4.22,3.67v.34a13.65,13.65,0,0,1,5.44,4.22,11,11,0,0,1,2.31,7.14,13,13,0,0,1-2.11,7.34,14.13,14.13,0,0,1-5.64,5A17.63,17.63,0,0,1,83,121.09ZM114.32,120V83.35l-7.62,5.44L103,83.14l13.47-9.65h5.23V120Z"></path><path class="cls-3" d="M32,20A12,12,0,0,0,20,32V136l18,8,18-8V56h80l8-18-8-18Z"></path><path class="cls-6" d="M20,136v24a12,12,0,0,0,12,12H56V136Z"></path><path class="cls-8" d="M172,56V32a12,12,0,0,0-12-12H136V56Z"></path></g></g></svg></div>
//     <div>On your Google Calendar</div>
//   </div>
//   <button  style="background-color: #2f59ec; color: white; border: none; padding: 10px 20px; font-size: 14px; border-radius: 6px; cursor: pointer;">
//     <a  style="text-decoration: none; color : white; href=${data.htmlLink}>Add to Calendar</a></button>
// </div>

//     </header>
//     <!-- Main Container -->
//     <div style="max-width: 1100px; margin: 0 auto; background-color: #ffffff;">
        
//         <!-- Header -->
      
        
  
//     <!-- Main Container -->
//     <div style=" margin: 0 auto; background-color: #ffffff;">
        
//         <!-- Header -->
//         <div style="padding: 20px 24px; border-bottom: 1px solid #e8eaed;">
            
//             <p style="margin: 0; font-size: 14px; color: #202124;">Hi ${data.name},</p>
//         </div>
//         <div style="display: flex;">
//  <!-- Meeting Details -->
//         <div style="padding: 0 24px 24px 24px;">
//             <p style="margin: 16px 0; font-size: 14px; color: #202124;">
//                 Therapy session  $  ${data.sessionTime} has been scheduled .
//             </p>
            
//           <!-- Session Confirmation -->
// <div style="margin: 24px 0;">
//     <p style="margin: 0 0 16px 0; font-size: 16px; color: #202124; font-weight: 600;">We've received your payment and your counselling session ${data.sessionTime} has been successfully scheduled.</p>
    
//     <div style="margin: 20px 0;">
//         <p style="margin: 0 0 12px 0; font-size: 14px; color: #202124; font-weight: 500;">Session Details:</p>
//         <div style="font-size: 14px; color: #202124; line-height: 1.6;">
//             <p style="margin: 8px 0;"><strong>Date:</strong> ${formatted_date} ${currentYear}</p>
//             <p style="margin: 8px 0;"><strong>Time:</strong> ${data.sessionTime}p>
          
//         </div>
//     </div>

   
//     <div style="margin: 20px 0;">
//         <p style="margin: 0 0 12px 0; font-size: 14px; color: #202124; font-weight: 500;">Important Notes:</p>
//         <div style="font-size: 14px; color: #202124; line-height: 1.5;">
//             <p style="margin: 8px 0;">• This is a confirmation email. Hence, no reply is required.</p>
//             <p style="margin: 8px 0;">• If you're running late, please inform us in advance on WhatsApp or contact our customer support. This helps ensure your session is not marked as a no-show. Therapists can wait for you, but without prior notice, the session will be considered missed and marked accordingly.</p>
//         </div>
//     </div>

//     <div style="margin: 20px 0;">
//         <p style="margin: 0 0 12px 0; font-size: 14px; color: #202124; font-weight: 500;">Need support?</p>
//         <p style="margin: 8px 0; font-size: 14px; color: #202124;">Feel free to message us on <a href="https://wa.me/+919120719120" style="color: #1967d2; text-decoration: none;">WhatsApp</a> for any assistance or questions.</p>
//         <p style="margin: 8px 0; font-size: 14px; color: #202124;">Stay connected with us on <a href="https://instagram.com/mento.in" style="color: #1967d2; text-decoration: none;">Instagram</a> for mental wellness insights and daily tips.</p>
//     </div>

//     <div style="margin: 20px 0;">
//         <p style="margin: 8px 0; font-size: 14px; color: #202124;">Thank you once again for trusting us with your mental wellness journey.</p>
//         <p style="margin: 8px 0; font-size: 14px; color: #202124;">We're with you, every step of the way 🌱</p>
//     </div>

//     <div style="margin: 20px 0;">
//         <p style="margin: 8px 0; font-size: 14px; color: #202124;">Warm regards,<br>Team Mento</p>
//         <p style="margin: 8px 0; font-size: 14px; color: #202124;"><a href="https://www.mento.in" style="color: #1967d2; text-decoration: none;">www.mento.in</a></p>
//     </div>

//     <div style="margin: 16px 0; font-size: 12px; color: #5f6368;">
//         <a href="https://www.instagram.com/mento.in" style="color: #1967d2; text-decoration: none; margin-right: 15px;">Instagram</a>
//         <a href="http://wa.me/9120719120" style="color: #1967d2; text-decoration: none; margin-right: 15px;">WhatsApp</a>
//         <a href="https://m.facebook.com/people/Mento/61566015786803" style="color: #1967d2; text-decoration: none; margin-right: 15px;">Facebook</a>
//         <a href="https://in.linkedin.com/company/connectmento" style="color: #1967d2; text-decoration: none;">LinkedIn</a>
//     </div>
// </div>

            
           
            
//             <!-- Location Info -->
         
            
//             <!-- Signature -->
//             <div style="margin: 32px 0 24px 0;">
                
//             </div>
//         </div>
        
//         <!-- Right Side Panel -->
//         <div style=" width: 50rem; background-color: #f8f9fa; padding: 24px; border-top: 1px solid #e8eaed;">
//             <p>Meeting Link</p>
//             <p ><a href=${data.meetLink} style="text-decoration: none; color: black; text-decoration: none; font-size: 14px; font-weight: 500;">
//                 ${data.meetLink}

//             </a>
                
//             </p>

//             <div style="background-color: #1a73e8; color: white; padding: 12px 24px; border-radius: 4px; text-align: center; margin-bottom: 16px;">
//                 <a href="#" style="color: white; text-decoration: none; font-size: 14px; font-weight: 500;">Join with Google Meet</a>
//             </div>
            
//             <div style="margin-bottom: 16px; ">
               
               
//              <div style="background-color: #009479; color: white; padding: 12px 24px; border-radius: 4px; text-align: center; margin-top: 20px;">
//                 <a href="#" style="color: white; text-decoration: none; font-size: 14px; font-weight: 500;">Need Support</a>
//             </div>
//             </div>
            
           
//         </div>
//     </div>
//         </div>
       


//         <!-- Two Column Section -->
       
//         <!-- Footer -->
//         <div style="padding: 16px 24px; border-top: 1px solid #e8eaed; text-align: center;">
//             <p style="margin: 0; font-size: 12px; color: #5f6368;">
//                 This invitation was sent by Mento
//             </p>
//         </div>
//     </div>
    
// </body>
// </html>


// `

// }

// export const MeetLinkPaymentToMento =({data})=>{
// if(!data){
//     throw new Error('data do not exist')
// }
// const date = new Date(data.sessionDate);


// const options = { weekday: 'long', month: 'long', day: 'numeric' };
// const formatted_date = date.toLocaleDateString('en-US', options);
// //  console.log(formatted); // 👉 "Friday, July 25"

//  // Output: Friday

//  const currentYear = new Date().getFullYear();
//    return `
//    <!DOCTYPE html>
// <html lang="en">
//   <head>
//     <meta charset="UTF-8" />
//     <meta name="viewport" content="width=device-width, initial-scale=1.0" />
//     <title>Session Scheduled - Therapist Notification</title>
//   </head>
//   <body
//     style="
//       margin: 0;
//       padding: 0;
//       font-family: 'Google Sans', Arial, sans-serif;
//       background-color: #ffffff;
//       color: #202124;
//     "
//   >
//     <header
//       style="max-width: 1100px; margin: 0 auto; background-color: #ffffff"
//     >
//       <div
//         style="
//           font-family: Arial, sans-serif;
//           border: 1px solid #e1e4e8;
//           border-radius: 8px;
//           padding: 20px;
//           background-color: #f9f9f9;
//         "
//       >
//         <div
//           style="
//             font-weight: bold;
//             font-size: 14px;
//             color: #444;
//             margin-bottom: 10px;
//           "
//         >
//           Mon, Jul 14 • 12:00 PM – 12:45 PM
//         </div>
//         <div
//           style="
//             font-size: 20px;
//             font-weight: 500;
//             color: #000;
//             margin-bottom: 15px;
//           "
//         >
//           New Therapy Session Scheduled - Client: ${data.name}
//         </div>
//         <div
//           style="
//             display: flex;
//             align-items: center;
//             margin-bottom: 10px;
//             color: #333;
//             font-size: 14px;
//           "
//         >
//           <div style="margin-right: 8px; font-size: 20px; line-height: 20px">
//             <svg
//               viewBox="0 -960 960 960"
//               height="24"
//               width="24"
//               focusable="false"
//               class="aoH"
//             >
//               <path
//                 d="M480.28-96q-13.7,0-23.49-7.5T443-123q-19-53-45.5-100.5T321-335q-49-63-79.5-121T211-595.21Q211-707 289.3-785.5T480-864t190.7,78.42T749-594.57Q749-507 715.5-449.5T639-335q-52,68-78.5,114.5T517-123q-5,12-14.5,19.5T480.28-96ZM480-223q17-34 38.5-67.27T582-379q42-54 68.5-100.36T677-595q0-81-58-139T479.5-792t-139,58T283-595q0,69.29 27,115.64T378-379q42,55.45 63.5,88.73T480-223Zm0-275q40,0 68.5-28.5T577-595t-28.5-68.5T480-692t-68.5,28.5T383-595t28.5,68.5T480-498Zm0-97Z"
//               ></path>
//             </svg>
//           </div>
//           <div ><a style ="text_decoration:none; color:white" href = ${data.meetLink}>Google Meet</a></div>
//         </div>
//         <div
//           style="
//             display: flex;
//             align-items: center;
//             margin-bottom: 10px;
//             color: #333;
//             font-size: 14px;
//           "
//         >
//           <div
//             style="margin-right: 1px; font-size: 20px; line-height: 20px"
//           ></div>
//           <div style="margin-left: rem">
//             <svg
//               viewBox="0 -960 960 960"
//               height="24"
//               width="24"
//               focusable="false"
//               class="aoH"
//             >
//               <path
//                 d="M96-192v-92q0-25.78 12.5-47.39T143-366q54-32 114.5-49T384-432t126.5,17T625-366q22,13 34.5,34.61T672-284v92H96Zm648,0v-92q0-42-19.5-78T672-421q39,8 75.5,21.5T817-366q22,13 34.5,34.67T864-284v92H744ZM384-480q-60,0-102-42T240-624t42-102t102-42t102,42t42,102T486-522T384-480ZM720-624q0,60-42,102T576-480q-8,0-15-0.5T546-483q25-29 39.5-64.5T600-624t-14.5-76.5T546-765q8-2 15-2.5t15-0.5q60,0 102,42t42,102ZM168-264H600v-20q0-6.47-3.03-11.76T589-304q-47-27-99-41.5T384-360T278-346t-99,42q-4.95,2.83-7.98,7.91T168-284.09V-264ZM384.21-552Q414-552 435-573.21t21-51T434.79-675t-51-21T333-674.79t-21,51T333.21-573t51,21ZM384-264Zm0-360Z"
//               ></path>
//             </svg>
//           </div>
//           <div style="padding-left: 1rem">Client: ${data.name}</div>
//         </div>
//         <div
//           style="
//             display: flex;
//             align-items: center;
//             margin-bottom: 20px;
//             font-weight: bold;
//             font-size: 14px;
//             color: #333;
//           "
//         >
//           <div style="margin-right: 8px">
//             <svg
//               id="Standard_product_icon"
//               data-name="Standard product icon"
//               width="24"
//               height="24"
//               viewBox="0 0 192 192"
//               focusable="false"
//               class="aoH"
//             >
//               <defs>
//                 <style>
//                   .cls-1 {
//                     fill: none;
//                   }
//                   .cls-2 {
//                     fill: #fff;
//                   }
//                   .cls-3 {
//                     fill: #4285f4;
//                   }
//                   .cls-4 {
//                     fill: #ea4335;
//                   }
//                   .cls-5 {
//                     fill: #34a853;
//                   }
//                   .cls-6 {
//                     fill: #188038;
//                   }
//                   .cls-7 {
//                     fill: #fbbc04;
//                   }
//                   .cls-8 {
//                     fill: #1967d2;
//                   }
//                 </style>
//               </defs>
//               <rect
//                 id="bounding_box"
//                 data-name="bounding box"
//                 class="cls-1"
//                 width="192"
//                 height="192"
//               ></rect>
//               <g id="art_layer" data-name="art layer">
//                 <g id="art_layer-2" data-name="art layer">
//                   <polygon
//                     class="cls-2"
//                     points="136 56 100 52 56 56 52 96 56 136 96 141 136 136 140 95 136 56"
//                   ></polygon>
//                   <polygon
//                     class="cls-4"
//                     points="136 172 172 136 154 128 136 136 128 154 136 172"
//                   ></polygon>
//                   <polygon
//                     class="cls-5"
//                     points="48 154 56 172 136 172 136 136 56 136 48 154"
//                   ></polygon>
//                   <polygon
//                     class="cls-7"
//                     points="136 56 136 136 172 136 172 56 154 48 136 56"
//                   ></polygon>
//                   <path
//                     class="cls-3"
//                     d="M83,121.09a17.84,17.84,0,0,1-6.46-1.23A16.62,16.62,0,0,1,70.8,116a16.4,16.4,0,0,1-3.74-6.8l6.87-2.79A10.4,10.4,0,0,0,77.26,112,8.65,8.65,0,0,0,83,114a9.08,9.08,0,0,0,4.15-1,7.73,7.73,0,0,0,3.13-2.65,6.77,6.77,0,0,0-1.43-9.25,10.12,10.12,0,0,0-6.6-2.1h-4V92.32h3.67a9,9,0,0,0,5.58-1.76,6,6,0,0,0,2.38-5.1A5.47,5.47,0,0,0,87.73,81a7.6,7.6,0,0,0-5.17-1.77,6.79,6.79,0,0,0-5.23,1.9A10.33,10.33,0,0,0,74.88,85l-6.67-2.79a15.69,15.69,0,0,1,2.52-4.35A15.09,15.09,0,0,1,75.49,74a14.86,14.86,0,0,1,7.07-1.56A17.07,17.07,0,0,1,90.18,74a12.63,12.63,0,0,1,5.17,4.49A11.37,11.37,0,0,1,97.25,85a10.54,10.54,0,0,1-1.9,6.53,12.2,12.2,0,0,1-4.22,3.67v.34a13.65,13.65,0,0,1,5.44,4.22,11,11,0,0,1,2.31,7.14,13,13,0,0,1-2.11,7.34,14.13,14.13,0,0,1-5.64,5A17.63,17.63,0,0,1,83,121.09ZM114.32,120V83.35l-7.62,5.44L103,83.14l13.47-9.65h5.23V120Z"
//                   ></path>
//                   <path
//                     class="cls-3"
//                     d="M32,20A12,12,0,0,0,20,32V136l18,8,18-8V56h80l8-18-8-18Z"
//                   ></path>
//                   <path
//                     class="cls-6"
//                     d="M20,136v24a12,12,0,0,0,12,12H56V136Z"
//                   ></path>
//                   <path
//                     class="cls-8"
//                     d="M172,56V32a12,12,0,0,0-12-12H136V56Z"
//                   ></path>
//                 </g>
//               </g>
//             </svg>
//           </div>
//           <div>Added to your Mento Calendar</div>
//         </div>
//         <button
//           style="
//             background-color: #2f59ec;
//             color: white;
//             border: none;
//             padding: 10px 20px;
//             font-size: 14px;
//             border-radius: 6px;
//             cursor: pointer;
//           "
//         >
//           <a style="text-decoration: none; color: white" href=${data.htmlLink}
//             >View in Calendar</a
//           >
//         </button>
//       </div>
//     </header>
//     <!-- Main Container -->
//     <div style="max-width: 1100px; margin: 0 auto; background-color: #ffffff">
//       <!-- Header -->

//       <!-- Main Container -->
//       <div style=" display :flex ;direction: columns ; background-color: #ffffff">
//         <!-- Header -->
        
//         <div style="display: flex">
//           <!-- Meeting Details -->
//           <div style="padding: 0 24px 24px 24px">
//             <p style="margin: 16px 0; font-size: 14px; color: #202124">
//               A new therapy session ${data.sessionTime} has been scheduled
//               with client ${data.name}.
//             </p>

//             <!-- Session Confirmation -->

//             <div style="margin: 24px 0">
//               <p
//                 style="
//                   margin: 0 0 16px 0;
//                   font-size: 16px;
//                   color: #202124;
//                   font-weight: 600;
//                 "
//               >
//                 A counselling session ${data.sessionTime} has been successfully
//                 booked and payment has been received.
//               </p>
//               <div style="margin: 20px 0">
//                 <p
//                   style="
//                     margin: 0 0 12px 0;
//                     font-size: 14px;
//                     color: #202124;
//                     font-weight: 500;
//                   "
//                 >
//                   Session Details:
//                 </p>
//                 <div style="font-size: 14px; color: #202124; line-height: 1.6">
//                   <p style="margin: 8px 0">
//                     <strong>Client:</strong> ${data.name}
//                   </p>
//                   <p style="margin: 8px 0">
//                     <strong>Date:</strong> ${formatted_date} ${currentYear}
//                   </p>
//                   <p style="margin: 8px 0">
//                     <strong>Time:</strong> ${data.sessionTime}
//                   </p>
//                   <p style="margin: 8px 0">
//                     <strong>Session Type:</strong> ${data.Date}
//                   </p>
//                   <p style="margin: 8px 0">
//                     <strong>Payment Status:</strong> ✅ Confirmed
//                   </p>
//                 </div>
//               </div>
//               <div style="margin: 20px 0">
//                 <p
//                   style="
//                     margin: 0 0 12px 0;
//                     font-size: 14px;
//                     color: #202124;
//                     font-weight: 500;
//                   "
//                 >
                 
//                 </div>
//               </div>

//               <div style="margin: 20px 0">
//                 <p
//                   style="
//                     margin: 0 0 12px 0;
//                     font-size: 14px;
//                     color: #202124;
//                     font-weight: 500;
//                   "
//                 >
//                   Important Reminders:
//                 </p>
//                 <div style="font-size: 14px; color: #202124; line-height: 1.5">
                    
//                 </div>
//               </div>

//               <div style="margin: 20px 0">
               
//               </div>

//               <div style="margin: 20px 0">
//                 <p style="margin: 8px 0; font-size: 14px; color: #202124">
//                   Best regards,<br />Mento Support Team
//                 </p>
//                 <p style="margin: 8px 0; font-size: 14px; color: #202124">
//                   <a
//                     href="https://www.mento.in"
//                     style="color: #1967d2; text-decoration: none"
//                     >www.mento.in</a
//                   >
//                 </p>
//               </div>

//               <div style="margin: 16px 0; font-size: 12px; color: #5f6368">
//                 <a
//                   href="https://www.instagram.com/mento.in"
//                   style="
//                     color: #1967d2;
//                     text-decoration: none;
//                     margin-right: 15px;
//                   "
//                   >Instagram</a
//                 >
//                 <a
//                   href="http://wa.me/9120719120"
//                   style="
//                     color: #1967d2;
//                     text-decoration: none;
//                     margin-right: 15px;
//                   "
//                   >WhatsApp</a
//                 >
//                 <a
//                   href="https://m.facebook.com/people/Mento/61566015786803"
//                   style="
//                     color: #1967d2;
//                     text-decoration: none;
//                     margin-right: 15px;
//                   "
//                   >Facebook</a
//                 >
//                 <a
//                   href="https://in.linkedin.com/company/connectmento"
//                   style="color: #1967d2; text-decoration: none"
//                   >LinkedIn</a
//                 >
//               </div>
//             </div>
//             <!-- Location Info -->

//             <!-- Signature -->
//             <div style="margin: 32px 0 24px 0"></div>
//           </div>

//           <!-- Right Side Panel -->
//           <div
//             style="
//               width: 50rem;
//               background-color: #f8f9fa;
//               padding: 24px;
//               border-top: 1px solid #e8eaed;
//             "
//           >
//             <p>Session Meeting Link</p>
//             <p>
//               <a
//                 href=${data.meetLink}
//                 style="
//                   text-decoration: none;
//                   color: black;
//                   text-decoration: none;
//                   font-size: 14px;
//                   font-weight: 500;
//                 "
//               >
//                 ${data.meetLink}
//               </a>
//             </p>

//             <div
//               style="
//                 background-color: #1a73e8;
//                 color: white;
//                 padding: 12px 24px;
//                 border-radius: 4px;
//                 text-align: center;
//                 margin-bottom: 16px;
//               "
//             >
//               <a
//                 href=${data.meetLink}
//                 style="
//                   color: white;
//                   text-decoration: none;
//                   font-size: 14px;
//                   font-weight: 500;
//                 "
//                 >Join with Google Meet</a
//               >
//             </div>

//             <div style="margin-bottom: 16px">
             

//               <div
//                 style="
//                   background-color: #009479;
//                   color: white;
//                   padding: 12px 24px;
//                   border-radius: 4px;
//                   text-align: center;
//                   margin-top: 20px;
//                 "
//               >
//                 <a
//                   href="http://wa.me/9120719120"
//                   style="
//                     color: white;
//                     text-decoration: none;
//                     font-size: 14px;
//                     font-weight: 500;
//                   "
//                   >Contact Support</a
//                 >
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>

//       <!-- Two Column Section -->

//       <!-- Footer -->
//       <div
//         style="
//           padding: 16px 24px;
//           border-top: 1px solid #e8eaed;
//           text-align: center;
//         "
//       >
       
//       </div>
//     </div>
//   </body>
// </html>
// `
// }



